module.exports = "/_next/static/images/ComprehensiveFiberFTTXSolutions-830285fdf021a922d442a44e49b535c7.webp";